import { LocalizedElement, sourceAttribute } from "../i18n/LocalizedCopy";
import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import { buildAuthHeaders } from "../forum/authHeaders";
import "./AdminNavigation.css";

export const ADMIN_SERVICES = [
  { to: "/admin", label: "Vue générale", icon: "⌂", end: true },
  { to: "/admin/operations", label: "Centre d’opérations", icon: "⌘" },
  { to: "/admin/transactions-services", label: "Transactions services", icon: "⇄" },
  { to: "/admin/ventes-flash", label: "Ventes flash", icon: "ϟ" },
  { to: "/admin/finances-vendeurs", label: "Finances vendeurs", icon: "€" },
  { to: "/admin/sports-loisirs", label: "Sports & loisirs", icon: "◎" },
  { to: "/admin/voyage", label: "Voyage", icon: "⌖" },
  { to: "/admin/confiance", label: "Confiance", icon: "◇" },
  { to: "/admin/statuts", label: "Statuts", icon: "◫" },
  { to: "/admin/crowdfunding", label: "Crowdfunding", icon: "◉" },
  { to: "/moderation/securite", label: "Sécurité", icon: "△" },
  { to: "/recompenses/partenaires/admin", label: "Partenaires", icon: "✦" },
];

export function isAdminServicePath(pathname) {
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  return ADMIN_SERVICES.some(({ to, end }) => (
    end ? path === to : (path === to || path.startsWith(`${to}/`))
  ));
}

export default function AdminNavigation() {
  useSourceLanguage();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      try {
        const response = await fetch("/api/features/admin/operations/notifications/?unread=true&page_size=1", { headers: buildAuthHeaders() });
        if (!response.ok) return;
        const payload = await response.json();
        if (active) setUnread(payload.unread_count || 0);
      } catch { /* Le compteur sera réessayé au prochain intervalle. */ }
    };
    refresh();
    const timer = window.setInterval(refresh, 15000);
    return () => { active = false; window.clearInterval(timer); };
  }, []);
  return (
    <LocalizedElement elementType={"nav"} copyAttributes={["aria-label"]} className="admin-service-nav" aria-label={sourceAttribute("Services d’administration")}>
      <div className="admin-service-nav__inner">
        <div className="admin-service-nav__identity" aria-hidden="true">
          <span>ADMIN</span>
          <strong><LocalizedText source={"Centre de contrôle"} /></strong>
        </div>
        <div className="admin-service-nav__links">
          {ADMIN_SERVICES.map(({ to, label, icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => (
                `admin-service-nav__link${isActive ? " is-active" : ""}`
              )}
            >
              <span aria-hidden="true">{<LocalizedText source={icon} />}</span>
              {<LocalizedText source={label} />}
              {to === "/admin/operations" && unread ? <small className="admin-service-nav__count">{unread}</small> : null}
            </NavLink>
          ))}
        </div>
      </div>
    </LocalizedElement>
  );
}
